import { Component } from 'preact';
import axios from 'axios';
import Item from './item'
//import WalmartGroceryItem from './walmartGroceryItem'
import VideoItem from './videoItem'
//import Loader from '../util/loader'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class ItemCarousel extends Component {

	updateDimensions = (e) => {

		let innerWidth

		if (e){
		 	innerWidth = e && e.target ? e.target.innerWidth : '100%'
		 } else {
			innerWidth = window && window.innerWidth ? window.innerWidth : '100%'
		 }

		this.setState({carouselWidth: innerWidth})
	}

	constructor() {
		super();
		// set initial time:
		let innerWidth = window && window.innerWidth ? window.innerWidth : '100%'
		this.state = { carouselItemsContent: 'loading', carouselWidth: innerWidth };
	}

	componentWillMount(){

		this.updateDimensions()

		let itemCarData = this.props.data
		let carouselItemsContent = []

		if (!itemCarData){
			throw new Error('!itemCarData')
		}

		window.addEventListener("resize", this.updateDimensions);

		let carouselItems = itemCarData && itemCarData.items
		let carouselTitle =  itemCarData && itemCarData.title

		if (!carouselItems || carouselItems.length === 0){
			throw new Error('!carouselItems')
		}

		//promiseArray
		let basicContentPromiseArray = []

		carouselItems.forEach( current => {

			if (current.itemId){
				//if only item id have to get data, otherwise content already exist
				basicContentPromiseArray.push( axios.get('https://columbus-c4de8.firebaseio.com/products/' + current.itemId + '/content/basicContent.json'))
			} else {
				basicContentPromiseArray.push( {data: current} )
			}

		})

		return Promise.all(basicContentPromiseArray).then ( results=> {

		results.forEach(current => {
			//only add if available online
			//33963184
			//if (current.data && current.data.stock !== 'Not available'){
				carouselItemsContent.push( current.data)
		//	}

		})

		this.setState({ carouselItemsContent , carouselTitle, errorMessage: null})

		}).catch( err => {
			console.error(err.message)
			this.setState({errorMessage: err.message, itemsData: null})
		})


	}


render(){

		let settings = {
			 dots: true,
			 infinite: true,
			 speed: 500,
			 slidesToShow: 4,
			 slidesToScroll: 4,
			 responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 300,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

		 };

		if (this.state.carouselItemsContent === 'loading'){
			return (
				null
			);
		} else if (this.state.errorMessage){
			return null
		} else if (this.props.website && this.props.website === 'walmartGrocery'){
			//hide if on walmart grocery
			return null
		}


		let listProduct = this.state.carouselItemsContent.map( current => {

				if (current.type === 'wistiaVideo'){
					return ( <VideoItem key={current.itemId} current={current} /> )
				//} else if (this.props.website && this.props.website === 'walmartGrocery') {
				} else if (this.props.website && this.props.website === 'walmartGrocery') {
					//return <WalmartGroceryItem key={current.itemId} current={current} />
					return null
				}
				return <Item key={current.itemId} current={current}  />

		})

		return (
			<div className='row ' style={{width: this.state.carouselWidth, maxWidth: '100%'}}>
					<div className='s1-header col-xs-12'>
						{this.state.carouselTitle}
					</div>

					<div className=" col-xs-12" >
						<div style={{height: '500px', alignItems: 'center'}} className="row col-xs-12">
							<div className="sliderContainer col-xs-12">
				        <Slider {...settings}>
				          {listProduct}
				        </Slider>
							</div>
						</div>
		      </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/contentTypes/itemCarousel/itemCarousel.js